export default __webpack_public_path__ + "static/media/verify-certificate.29230f43.png";